import apiClient from './client';
import type { ApiResponse } from '@/types';

export type NotificationType = 'demand_assigned' | 'quotation_done' | 'system';

export interface NotificationItem {
  id: string;
  tenantId: string;
  userId: string;
  type: NotificationType;
  title: string;
  body: string | null;
  refType: string | null;
  refId: string | null;
  isRead: boolean;
  createdAt?: string;
}

export interface NotificationListResult {
  items: NotificationItem[];
  total: number;
  unreadCount: number;
}

const unwrap = async <T>(p: Promise<{ data: ApiResponse<T> }>): Promise<T> => {
  const resp = await p;
  return resp.data.data as T;
};

export const notificationApi = {
  /** 我的通知列表（含未读总数） */
  list: (params?: { limit?: number; offset?: number }) =>
    unwrap<NotificationListResult>(apiClient.get('/notifications', { params })),
  /** 未读数量 */
  unreadCount: () => unwrap<{ count: number }>(apiClient.get('/notifications/unread-count')),
  /** 标记单条已读 */
  markRead: (id: string) => unwrap<{ id: string }>(apiClient.post(`/notifications/${id}/read`)),
  /** 标记全部已读 */
  markAll: () => unwrap<{ count: number }>(apiClient.post('/notifications/read-all')),
};

export default notificationApi;
